<sim-basic-material-dialog
	(closeClicked)="close()"
	[finished]="finished"
	[headerIcon]="{fontIcon: 'fa-file-signature', fontSet: 'fad'}"
	[headerText]="myDialogTitle"
	[matDialogData]="data"
	[overflowHandledByChild]="true"
	[rect]="rect"
	class="normalDuotoneHeaderIcon"
>
	<ng-container dialogContent>
		<div class="uploadBtnns">
			<input (change)="onFileSelected($event)" accept=".xlsx, .xls" id="fileInput" type="file" />
			<button (click)="uploadExcelFile()" [disabled]="!excelLoaded" color="accent" mat-raised-button style="margin-right: 10px">
				{{ T.BUTTON_UPLOAD | translate }}
			</button>
		</div>
	</ng-container>
</sim-basic-material-dialog>
